import { useEffect, useState } from 'react'

import { quantApi } from '@/app/lib/quant/quantApi'
import type { IndicatorType } from '@/app/lib/quant/types'
import { describeError } from '@/app/lib/apiError'

export type QuantIndicatorCatalogState =
  | { status: 'loading' }
  | { status: 'ready'; types: IndicatorType[] }
  | { status: 'error'; message: string }

/** The indicator catalog (`quantApi.listIndicatorCatalog`), fetched once per mount; `retry` refetches. */
export function useQuantIndicatorCatalog(): QuantIndicatorCatalogState & { retry: () => void } {
  const [state, setState] = useState<QuantIndicatorCatalogState>({ status: 'loading' })
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    let cancelled = false
    quantApi
      .listIndicatorCatalog()
      .then((types) => {
        if (!cancelled) setState({ status: 'ready', types })
      })
      .catch((err: unknown) => {
        if (!cancelled) setState({ status: 'error', message: describeError(err, 'Could not load indicators') })
      })
    return () => {
      cancelled = true
    }
  }, [attempt])

  return {
    ...state,
    retry: () => {
      setState({ status: 'loading' })
      setAttempt((n) => n + 1)
    },
  }
}
